import { useDispatch, useSelector } from 'react-redux';

import { LegacyRef, ReactNode, useEffect } from 'react';
// @ts-ignore todo change to TS
import { getFieldErrors, getFormError } from 'lib/src/redux/selectors/fieldErrors';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import ActionButton from 'lib/src/components/button/ActionButton';
import { isEmpty } from 'lib/src/utils/generic';
import { clearFormError, showFieldErrors } from 'lib/src/redux/actions/fieldErrors';

const Form: React.FC<FormProps> = ({
    children,
    onSubmit,
    onCancel = () => {},
    onInit = () => {},
    omitButtons = false,
    omitSubmitButton = false,
    omitCancelButton = false,
    isPosting = false,
    className,
    omitValidation = false,
    innerRef,
    error,
    submitText = 'Submit',
    cancelText = 'Cancel',
    submitColor = 'green',
}) => {
    const dispatch = useDispatch();
    const fieldErrors = useSelector(getFieldErrors);
    const formError: string | null = useSelector(getFormError);

    useEffect(() => {
        onInit();
    }, []);

    return (
        <form onSubmit={_handleSubmit} className={className} ref={innerRef}>
            {children}
            {!!formError && <p className="form-generic-error">{formError}</p>}
            {!!error && <p className="form-generic-error">{error}</p>}
            {!omitButtons && (
                <ButtonRow alignment="right">
                    {!omitCancelButton && (
                        <ActionButton
                            color="grey"
                            type="button"
                            onClick={_handleCancel}
                            disabled={isPosting}
                        >
                            {cancelText}
                        </ActionButton>
                    )}
                    {!omitSubmitButton && (
                        <ActionButton color={submitColor} isPosting={isPosting}>
                            {submitText}
                        </ActionButton>
                    )}
                </ButtonRow>
            )}
        </form>
    );

    function _handleCancel(e: React.MouseEvent) {
        e.preventDefault();

        if (!isPosting) onCancel();
    }

    function _handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        if (!isEmpty(fieldErrors) && !omitValidation) {
            dispatch(showFieldErrors());
        } else if (!isPosting && !omitValidation) {
            dispatch(clearFormError());
            onSubmit();
        } else if (omitValidation) {
            onSubmit();
        }
    }
};

interface FormProps {
    children?: ReactNode;
    isPosting?: boolean;
    omitButtons?: boolean;
    omitSubmitButton?: boolean;
    omitCancelButton?: boolean;
    onSubmit: () => void;
    onCancel?: () => void;
    onInit?: () => void;
    className?: string;
    innerRef?: LegacyRef<HTMLFormElement>;
    omitValidation?: boolean;
    error?: string | null;
    submitText?: string;
    cancelText?: string;
    submitColor?: string;
}

export default Form;
